import { Pipe, PipeTransform } from '@angular/core';
import { memoize } from 'lodash-es';
import { get_text_color_from_hex, OptionalValue } from '../shared/utils/common';

@Pipe({
  name: 'bg_text_color',
  pure: false,
})
export class BackgroundTextColorPipe implements PipeTransform {
  transform = memoize((hex: OptionalValue<string>, fallback?: string) => get_text_color_from_hex(hex, {
    fallback: () => fallback,
  }));
}